import React from 'react';
import { Grid } from 'semantic-ui-react';
import { AMOUNT_OF_COLUMNS } from './PopupContent.constants';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import { generateKey } from '../../../Links/Links.utils';
import AccordionLinks from '../AccordionLinks';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import './PopupContent.css';
var defaultProps = {
  onMouseEnter: function onMouseEnter() {
    return null;
  },
  onMouseLeave: function onMouseLeave() {
    return null;
  },
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  initialActiveIndices: [],
  onLinkClick: function onLinkClick() {
    return null;
  }
};
export default function PopupContent(_ref) {
  var links = _ref.links,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    maxLinksToShow = _ref.maxLinksToShow,
    initialActiveIndices = _ref.initialActiveIndices,
    onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/React.createElement(Grid, {
    className: "popup-content",
    stackable: true,
    doubling: true,
    columns: AMOUNT_OF_COLUMNS,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, links.map(function (link, index) {
    var title = link.title,
      url = link.url,
      slug = link.slug;
    var key = generateKey(title, url, slug);
    return /*#__PURE__*/React.createElement(Grid.Column, {
      key: key
    }, /*#__PURE__*/React.createElement(AccordionLinks, {
      link: link,
      maxLinksToShow: maxLinksToShow,
      onLinkClick: onLinkClick,
      initialActive: initialActiveIndices.includes(index)
    }));
  }));
}
PopupContent.defaultProps = defaultProps;